import { styled } from "styled-components"

export const StepContainer = styled.div`
  flex-grow: 0.95;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`
